import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import FavoriteIcon from 'core/modules/FavoriteIcon/FavoriteIcon';
import MerchantRebateV2 from 'core/modules/MerchantRebateV2/MerchantRebateV2';
import ExtraRewardsPill from 'core/modules/ExtraRewardsPill/ExtraRewardsPill';
import Tile from 'core/modules/Tile/Tile';

import config from './configs';

import './MerchantWithOfferCountTile.scss';

function MerchantWithOfferCountTile({ merchant, rebateOptions }) {
  const {
    id,
    name,
    logoUrls,
    rebate,
    offers,
  } = merchant;

  const { offersCountAdditionalText, label } = config;
  const offersCountText = offers.length === 1 ? 'offer' : 'offers';
  const rebateConfig = { ...config.rebateOptions, ...rebateOptions };

  return (
    <ComponentErrorBoundary>
      <div
        className="mn_merchantWithOfferCountTile mn_favoriteItemWrap"
        data-merchant-id={id}
        data-merchant-name={name}
      >
        <Tile>
          <div className="mn_tileContentWrap">
            <div className="mn_merchantLogoWithRebate">
              <FavoriteIcon merchantId={id} merchantName={name} />
              <img src={logoUrls._120x60} alt={name} />
              <h3>{`${offers.length} ${offersCountText} ${offersCountAdditionalText}`}</h3>
              <ExtraRewardsPill rebate={rebate} label={label} />
              <MerchantRebateV2 {...rebate} {...rebateConfig} />
            </div>
          </div>
        </Tile>
      </div>
    </ComponentErrorBoundary>
  );
}

export default MerchantWithOfferCountTile;
